export default __webpack_public_path__ + "static/media/contact-hero-600.8fc13a39.svg";